import { Alert } from "@mui/material"

import { GestaoVagaOcupacaoDia } from "./GestaoVagaOcupacao.jsx"
import { resolverIngressoVaga } from "./gestaoVagaIngressoMock.js"

/**
 * Resumo da vaga exibido abaixo do botão após ingresso/atualização.
 */
export default function GestaoVagaResumoAposAcao({ dadosApi, tituloFallback = "" }) {
	if (!dadosApi?.ingresso) return null

	const ingresso = resolverIngressoVaga({ ingresso: dadosApi.ingresso })
	const titulo =
		dadosApi?.vaga?.titulo || tituloFallback || `Vaga #${dadosApi?.idVaga || ""}`

	const diaInscrito = (ingresso.dias ?? []).find(
		(d) => d.data === dadosApi.data || d.jaInscrito
	)

	return (
		<div className="gv-resumo-apos-acao mt-3">
			<Alert severity="success" className="mb-2">
				<strong>{titulo}</strong>
				<span className="block text-sm mt-1 font-normal">
					Dia: {dadosApi.dataFormatada || dadosApi.data || "—"}
					{dadosApi.idTitular ? ` · titular #${dadosApi.idTitular}` : ""}
				</span>
			</Alert>
			{diaInscrito ? <GestaoVagaOcupacaoDia dia={diaInscrito} /> : null}
		</div>
	)
}
